document.addEventListener('DOMContentLoaded', function() {

  $('.custom_variant_auto').click(function(event){
      event.stopPropagation();
      var $list = $(this).next('.custom_variant_list');
      $('.custom_variant_list').not($list).hide();
      $list.toggle();
  });

  $(document).click(function(event) {
      if (!$(event.target).closest('.custom_variant_auto, .custom_variant_list').length) {
          $('.custom_variant_list').hide(); 
      }
  });

  function checkAndRun() {
      var isChecked1 = $('.custom_variant_list').eq(0).find('input[type="checkbox"]:checked').length > 0;
      var isChecked2 = $('.custom_variant_list').eq(1).find('input[type="checkbox"]:checked').length > 0;

    var checkedCount1 = $('.custom_variant_list').eq(0).find('input[type="checkbox"]:checked').length;
    var checkedCount2 = $('.custom_variant_list').eq(1).find('input[type="checkbox"]:checked').length;

    if (isChecked1){
      $('.custom_variant_auto.upper').text(`${checkedCount1} Items Selected`);
    }else{
      $('.custom_variant_auto.upper').text(`Choose an option`);
    }
    if (isChecked2){
      $('.custom_variant_auto.last').text(`${checkedCount2} Items Selected`);
    }else{
      $('.custom_variant_auto.last').text(`Choose an option`);
    }
    
    

      var addToCartButton = $('#add-to-cart-button');

       // Calculate total price
        var totalPrice = 0;
        $('.custom_variant_data__ input[type="checkbox"]:checked').each(function() {
            var price = parseInt($(this).data('multiple-price'), 10);
            totalPrice += price;
        });
        var formattedPrice = (totalPrice / 100).toFixed(2);
        
        // Update the UI for the total price
        $('.multiple-price').text("$" + formattedPrice);
    
      if (isChecked1 && isChecked2) {
          console.log("Both blocks have at least one checkbox checked!");
          addToCartButton.prop('disabled', false);
          $(addToCartButton).addClass('active');
      }else{
          console.log("Both blocks have not checked");
          addToCartButton.prop('disabled', true);
          $(addToCartButton).removeClass('active');
      }
  }

  
  $('.custom_variant_list input[type="checkbox"]').on('change', function() {
      checkAndRun(); 
    
  });

  // $('.custom_variant_list.main___selector input[type="checkbox"]').on('change', function() {
  //   // Gallery Logic ####
  //   const index = $('.custom_variant_list input[type="checkbox"]').index(this);
  //   console.log('Latest checked index:', index + 1);
  //   $(`.gallery_helper_option option:nth-child(${index + 2})`).prop('selected', true);

  //   const dropdownEvent = new Event('change', { bubbles: true });
  //   document.querySelector('.gallery_helper_option').dispatchEvent(dropdownEvent);
  // });

  $('.custom_variant_list input[type="checkbox"]').on('change', function() {
    // Gallery Logic ####
    const index = $(this).attr('data-variant-title');
    console.log(`content: ${index}`);
    $(`.gallery_helper_option option[data-variant-title='${index}']`).prop('selected', true);

    const dropdownEvent = new Event('change', { bubbles: true });
    document.querySelector('.gallery_helper_option').dispatchEvent(dropdownEvent);
  });
  

  $('#add-to-cart-button').click(function(e){
      e.preventDefault();
      
      var items = [];
      
      $('.custom_variant_list input[type="checkbox"]:checked').each(function() {
          if (this.id !== 'box_1_custom') {  
              var varId = $(this).val(); 
              var quantity = 1; 
              items.push({
                  id: varId,
                  quantity: quantity
              });
          }
      });
  
      var data = {
          items: items
      };
  
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: JSON.stringify(data), 
          contentType: "application/json; charset=utf-8", 
          success: function() {
              updateCartCounter()
              // window.location.href = '/cart';
          },
          error: function(xhr, status, error) {
              alert('Something went wrong: ' + error);
          }
      });
  });

  function updateCartCounter() {
    const newCount = Array.from(document.querySelectorAll('.custom_variant_list input[type="checkbox"]:checked'))
                           .filter(checkbox => checkbox.id !== 'box_1_custom')
                           .length;
    const cartCountElements = document.querySelectorAll('.cart_count');
    cartCountElements.forEach(cartCountElement => {
        cartCountElement.textContent = newCount;
    });
  }

  
  // OLD CODE #######
  
    const form = document.getElementById('add-multiple-variants-form');
    const variant1Select = form.querySelector('[name="variant1-id"]');
    const variant2Select = form.querySelector('[name="variant2-id"]');
    const defaultPrice = parseFloat(form.dataset.defaultPrice);

    function updateButtonState(event) {

      console.log('change...')
      const changedSelect = event.target;
      if(variant1Select.selectedOptions[0]?.dataset.unavailable) variant1Select.setAttribute("data-unavailable",true)
        else variant1Select.removeAttribute("data-unavailable")
      if(variant2Select.selectedOptions[0]?.dataset.unavailable) variant2Select.setAttribute("data-unavailable",true)
        else variant2Select.removeAttribute("data-unavailable")
      if(changedSelect.value) {
        const originalSelect = document.querySelector('.single-option-selector');
        originalSelect.value = changedSelect.options[changedSelect.selectedIndex].dataset.variantTitle;
        const newEvent = new Event('change');
        originalSelect.dispatchEvent(newEvent);
      }
    }
  
  
    variant1Select.addEventListener('change', updateButtonState);
    variant2Select.addEventListener('change', updateButtonState);
  

  // OLD CODE #######
    
});





 